module.exports = __webpack_public_path__ + "img/building95-3.ed0682e8.jpg";